// List View Icon:

import React from 'react'

const ListView = () => (
  <svg width="20" viewBox="0 0 16 16">
    <path
      d="M0 0v2h2v-2h-2zm4 0v2h12v-2h-12zm-4 4v2h2v-2h-2zm4 0v2h9v-2h-9zm-4 4v2h2v-2h-2zm4 0v2h12v-2h-12zm-4 4v2h2v-2h-2zm4 0v2h11v-2h-11z"
      transform="translate(0 1)"
    />
  </svg>
)

export default ListView
